import "./SideDrawer.css";
import React, { Component } from "react";
import ParentMenu from "./ParentMenu";
import {connect} from "react-redux";
import StudentMenu from "./StudentMenu";
import Container from "@material-ui/core/Container";

class SideDrawer extends Component {
  constructor(props) {
    super(props);
    console.log(this.props);
    this.state = {
      drawerClasses: "side-drawer",
      my_account_path: "",
    };  
  };

  
  render() {
    let show;
    if (this.props.currUser.type === "parent") {
       show = <ParentMenu closeMenu={this.props.closeMenu} userData={this.props.userData}/>
    } else {
       show = <StudentMenu closeMenu={this.props.closeMenu} userData={this.props.userData}/>
    }
    return(
      <Container component="main" maxWidth="xs">
      {show}
      </Container>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    currUser: state.currentUser,
  };
};


export default connect(mapStateToProps)(SideDrawer);
